module.exports = __webpack_public_path__ + "static/media/logoMark.f592890d.svg";